import { render, staticRenderFns } from "./DashTag.vue?vue&type=template&id=84c9f840&scoped=true"
import script from "./DashTag.vue?vue&type=script&setup=true&lang=js"
export * from "./DashTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashTag.vue?vue&type=style&index=0&id=84c9f840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9f840",
  null
  
)

export default component.exports